import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { STATUS } from "../constants/avatar";
import { millisecondsToTime } from "../lib/common";
import { AvatarAction } from "../redux/actions/AvatarAction";


const LimitTimer = ({ avatarItem, CheckAvatarId }) => {
  // eslint-disable-next-line no-unused-vars
  const [domStyle, setDomStyle] = useState({ display: "none" });
  // eslint-disable-next-line no-unused-vars
  const [leftTimes, setLeftTimes] = useState({ hour: "00", min: "00", sec: "00", timestamp: 0 });
  const timerRef = useRef({ interval: null });

  useEffect(() => {
    if (
      avatarItem?._id &&
      avatarItem?.status === STATUS.NEW &&
      avatarItem?.expiredAt
    ) {
      const calcTime = () => {
        const leftTimestamp = avatarItem.expiredAt - (new Date().getTime());
        const leftTime = millisecondsToTime(leftTimestamp);
        setLeftTimes({ ...leftTime, timestamp: leftTimestamp });
        if (leftTimestamp <= 0) {
          timerRef?.interval && clearInterval(timerRef.interval);
          CheckAvatarId(avatarItem._id, avatarItem.region);
        }
      };
      timerRef?.interval && clearInterval(timerRef.interval);
      const leftTimestamp = avatarItem.expiredAt - (new Date().getTime());
      if (leftTimestamp > 1000 * 3) {
        timerRef.interval = setInterval(calcTime, 1000);
      }
      setDomStyle({
        display: "inline-block",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 10000,
      });
    } else {
      setDomStyle({ display: "none" });
    }
    return () => {
      timerRef?.interval && clearInterval(timerRef.interval);
    }
  }, [CheckAvatarId, avatarItem]);

  return <>
    {/* <div style={domStyle}>
      <div className="d-inline-flex gap-1 align-items-center">
        {leftTimes?.hour && leftTimes?.hour !== "00" && <div>
          {leftTimes?.hour} :
        </div>}
        {leftTimes?.min && <div>
          {leftTimes?.min} :
        </div>}
        
        {leftTimes?.sec && <div>
          {leftTimes?.sec}
        </div>}
      </div>
    </div> */}
  </>
};

const mapState = (state) => {
  const avatarItem = state.AvatarReducer.item;
  return { avatarItem };
};

const mapDispatch = dispatch => ({
  CheckAvatarId: (id, region) => dispatch(AvatarAction.CheckAvatarId(id, region))
});

export default connect(mapState, mapDispatch)(LimitTimer);
